import { PlaycastMessage, PlaycastMessageSource, PlaycastMessageTarget } from '../../types';
import { generateMessageHeader } from './generateHeader';
import { generateSignature } from './generateSignature';

export const formatMessage = (
  hostId: string,
  source: PlaycastMessageSource,
  body: PlaycastMessageTarget,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageTarget> => {
  const header: PlaycastMessage<PlaycastMessageTarget>['header'] = {
    ...generateMessageHeader(hostId, source, userAuth),
    target: body.target,
    action: body.action,
    isReply: body.isReply,
  };

  const signature = generateSignature(JSON.stringify(header));

  return {
    signature,
    header,
    body: {
      message: body.message,
      timings: [],
      stats: [],
      echo: false,
    },
  };
};
